/**
 * ManageTypesDialog - Dialog para gerenciar tipos de operação
 */
import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Badge } from "../../ui/badge";
import { Plus, X } from "lucide-react";

export function ManageTypesDialog({
  open,
  onOpenChange,
  tiposOperacao,
  onAdicionarTipo,
  onRemoverTipo
}) {
  const [novoTipo, setNovoTipo] = useState("");

  const handleAdicionar = async () => {
    const sucesso = await onAdicionarTipo(novoTipo);
    if (sucesso) {
      setNovoTipo("");
    }
  };

  const handleRemover = async (tipo) => {
    if (window.confirm(`Excluir o tipo "${tipo}"?`)) {
      await onRemoverTipo(tipo);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Gerenciar Tipos de Operação</DialogTitle>
          <DialogDescription>
            Adicione ou remova tipos de operação
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Novo Tipo de Operação</Label>
            <div className="flex gap-2">
              <Input
                placeholder="Ex: SAQUE ANIVERSÁRIO"
                value={novoTipo}
                onChange={(e) => setNovoTipo(e.target.value)}
                className="flex-1"
                data-testid="input-novo-tipo"
              />
              <Button 
                onClick={handleAdicionar} 
                className="bg-emerald-600 hover:bg-emerald-700"
                data-testid="btn-adicionar-tipo"
              >
                <Plus className="h-4 w-4" />
              </Button>
            </div>
          </div>
          
          <div className="space-y-2">
            <Label className="text-sm text-slate-500">Tipos existentes (clique no X para excluir):</Label>
            <div className="flex flex-wrap gap-2 p-3 bg-slate-50 rounded-lg max-h-[200px] overflow-y-auto">
              {tiposOperacao.map((tipo, idx) => (
                <Badge 
                  key={`tipo-${idx}`}
                  variant="outline" 
                  className="text-sm py-1 px-2 flex items-center gap-1 bg-white"
                >
                  {tipo}
                  <button
                    onClick={() => handleRemover(tipo)}
                    className="ml-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full p-0.5"
                    data-testid={`btn-remover-tipo-${tipo}`}
                  >
                    <X className="h-3 w-3" />
                  </button>
                </Badge>
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
